export default __webpack_public_path__ + "static/01-bf9d329d250a6dff9b8e60e1b81f9798.jpg";